import React from 'react';
import { connect } from 'react-redux';
import GLOBAL_STYLES from '../styles';
import {
  getHoursMinutes,
  convertTimestampDate,
  convertTimestampMD, getWeightUom,
} from '../helpers/misc';
import { Form } from 'react-bootstrap';
import cloneDeep from 'lodash.clonedeep';


const mapStateToProps = state => ({
  colorScheme: state.main.colorScheme,
  openMachine: state.app.openMachine,
  authorizedModules: state.main.authorizedModules,
});

const CurrentJob = props => {
  const {
    scheduleObj,
    jobs,
    colorScheme,
    timeNow,
    isLast,
    openMachine,
    authorizedModules,
    updateShifts,
  } = props;
  
  const jobArr = jobs.find(jobArr => jobArr.some(jobObj => scheduleObj.jobNumbers.includes(jobObj.jobNumber)));
  const weightUom = getWeightUom(jobs?.[0]?.[0]?.jobLocator);
  const remainingQty = jobArr?.length ?
    jobArr.reduce((total, cur) => total + cur.startQty, 0) - jobArr.reduce((total, cur) => total + (cur?.actualGoodParts ? cur.actualGoodParts : 0), 0) : 0;
  const totalMaterials = jobArr?.length ? [...jobArr.reduce((totals, job) => {
    if(!job.partMaterials) return totals;
    job.partMaterials.forEach(material => {
      let matTotal = totals.get(material.materialNumber) ?? 0;
      matTotal += material.requiredQuantity;
      totals.set(material.materialNumber, matTotal);
    });
    return totals;
  }, new Map()).entries()] : [];
  const remainingMaterials = jobArr?.length ? [...jobArr.reduce((totals, job) => {
    if(!job.partMaterials) return totals;
    job.partMaterials.forEach(material => {
      let matTotal = totals.get(material.materialNumber) ?? 0;
      matTotal += material.requiredQuantity - (((job.actualGoodParts ?? 0) * material.quantityPerAssembly) / material.componentYieldFactor) > 0 ?
        material.requiredQuantity - (((job.actualGoodParts ?? 0) * material.quantityPerAssembly) / material.componentYieldFactor) :
        0;
      totals.set(material.materialNumber, matTotal);
    });
    return totals;
  }, new Map()).entries()] : [];
  const totalContainers = jobArr?.length ? jobArr.reduce((total, job) => total + (!job.containerQuantity ? 0 : Math.ceil(job.startQty / job.containerQuantity)), 0) : 0;
  const remainingContainers = remainingQty && jobArr?.[0]?.containerQuantity ? Math.ceil(remainingQty / jobArr[0].containerQuantity) : 0;
  
  let shiftNames = [];
  if(openMachine.machineCategory === 'ASSEMBLY') {
    if(scheduleObj.shifts) shiftNames = scheduleObj.shifts;
    else {
      shiftNames = openMachine?.standards?.shiftTimes ? [...openMachine.standards.shiftTimes.reduce((set, cur) => {
        set.add(cur.shiftName);
        return set;
      }, new Set()).values()].sort() : [];
      shiftNames = shiftNames.map(name => {
        const curShiftObj = scheduleObj.shifts ? scheduleObj.shifts.find(o => o.name = name) : null;
        if(!curShiftObj) return {
          name,
          enabled: true,
        };
        return {
          name,
          enabled: curShiftObj.enabled,
        };
      });
    }
  }
  
  return (
    <div
      style={{
        ...styles.container,
        borderColor: GLOBAL_STYLES[colorScheme].fgColor,
        marginBottom: isLast ? 20 : 0,
      }}
    >
      <p style={styles.text}>
        <span style={styles.title}>
          {`JOB${scheduleObj.jobNumbers.length > 1 ? 'S' : ''}: `}
        </span>
        {scheduleObj.jobNumbers.join(' & ')}
      </p>
      <p style={styles.text}>
        <span style={styles.title}>
          {`TOOL: `}
        </span>
        {jobArr ? `${jobArr[0].toolNumber}${jobArr[0].toolLocation ? ` (${jobArr[0].toolLocation})` : ''}` : null}
      </p>
      {jobArr && jobArr[0].lastPmDate ?
        <p style={styles.text}>
          <span style={styles.title}>
            {`LAST PM: `}
          </span>
          {convertTimestampDate(jobArr[0].lastPmDate)}
        </p> :
        null
      }
      {jobArr && jobArr[0].pmCycle ?
        <p style={styles.text}>
          <span style={styles.title}>
            {`PM CYCLE: `}
          </span>
          {`${(((jobArr[0].cycleCount ? jobArr[0].cycleCount : 0) / jobArr[0].pmCycle) * 100).toFixed(0)}%`}
        </p> :
        null
      }
      <p style={styles.text}>
        <span style={styles.title}>
          {`PART${scheduleObj.jobNumbers.length > 1 ? 'S' : ''}: `}
        </span>
        {jobArr ? jobArr.map(j => j.partNumber).join(' & ') : null}
      </p>
      <p style={styles.text}>
        <span style={styles.title}>
          {`TOTAL QTY: `}
        </span>
        {jobArr ? jobArr.reduce((total, cur) => total + cur.startQty, 0) : null}
      </p>
      <p style={styles.text}>
        <span style={styles.title}>
          {`COMPLETED QTY: `}
        </span>
        {jobArr ? jobArr.reduce((total, cur) => total + (cur?.actualGoodParts ? cur.actualGoodParts : 0), 0) : null}
      </p>
      <p style={styles.text}>
        <span style={styles.title}>
          {`REMAINING QTY: `}
        </span>
        {remainingQty ? remainingQty : null}
      </p>
      <p style={styles.text}>
        <span style={styles.title}>
          {`MATERIALS: `}
        </span>
        {totalMaterials?.length ? totalMaterials.map(([materialNumber, total]) => `${materialNumber} (${Math.round(total)} ${weightUom})`).join(', ') : null}
      </p>
      <p style={styles.text}>
        <span style={styles.title}>
          {`MATERIALS REMAINING: `}
        </span>
        {remainingMaterials?.length ? remainingMaterials.map(([materialNumber, total]) => `${materialNumber} (${Math.round(total)} ${weightUom})`).join(', ') : null}
      </p>
      <p style={styles.text}>
        <span style={styles.title}>
          {`CONTAINERS: `}
        </span>
        {jobArr?.[0]?.containerPartNumber ? `${jobArr?.[0]?.containerPartNumber} (${totalContainers})` : null}
      </p>
      <p style={styles.text}>
        <span style={styles.title}>
          {`CONTAINERS REMAINING: `}
        </span>
        {jobArr?.[0]?.containerPartNumber ? `${jobArr?.[0]?.containerPartNumber} (${remainingContainers})` : null}
      </p>
      <p style={styles.text}>
        <span style={styles.title}>
          {`TIME LEFT: `}
        </span>
        {jobArr ? getHoursMinutes(jobArr[0].actualEstimatedEndDate ?
          jobArr[0].actualEstimatedEndDate - timeNow :
          jobArr[0].actualStartDate + jobArr[0].stdTotalRunTime - timeNow,
        ) : null}
      </p>
      {openMachine.machineCategory === 'ASSEMBLY' ?
        <div style={styles.shiftRow}>
          <p style={styles.text}>
            <span style={styles.title}>
              {`SHIFTS: `}
            </span>
          </p>
          {shiftNames.map(({ name, enabled }, index, arr) => (
            <Form.Check
              key={name}
              style={styles.shiftCheck}
              type="checkbox"
              label={name}
              disabled={authorizedModules.includes('READ_ONLY') || (enabled && arr.filter(o => o.enabled).length === 1)}
              checked={enabled}
              onChange={e => {
                const newShiftNames = cloneDeep(shiftNames);
                newShiftNames[index].enabled = e.target.checked;
                updateShifts(newShiftNames);
              }}
            />
          ))}
        </div> :
        null
      }
      <p style={styles.text}>
        <span style={styles.title}>
          {`START: `}
        </span>
        {jobArr ? convertTimestampMD(jobArr[0].actualStartDate) : null}
      </p>
      <p style={styles.text}>
        <span style={styles.title}>
          {`REQUIRED END: `}
        </span>
        {jobArr ? convertTimestampDate(jobArr[0].scheduledCompletionDate) : null}
      </p>
      <p style={styles.text}>
        <span style={styles.title}>
          {`ESTIMATED END: `}
        </span>
        {jobArr ? convertTimestampMD(jobArr[0].actualEstimatedEndDate ?
          jobArr[0].actualEstimatedEndDate :
          jobArr[0].actualStartDate + jobArr[0].stdTotalRunTime,
        ) : null}
      </p>
      <p style={styles.text}>
        <span style={styles.title}>
          {`NOTES: `}
        </span>
        {scheduleObj.notes ? scheduleObj.notes : ''}
      </p>
    </div>
  );
};

const styles = {
  container: {
    userSelect: 'none',
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
    margin: 0,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 1,
    borderStyle: 'dashed',
    backgroundColor: GLOBAL_STYLES.CONSTANTS.orangeColor,
  },
  title: {
    fontWeight: 'bold',
  },
  text: {
    margin: 0,
    padding: 0,
  },
  shiftRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  shiftCheck: {
    marginLeft: 15,
  },
};

export default connect(mapStateToProps)(CurrentJob);